const nonDesktopBreakpoint = window.matchMedia("(max-width: 991px)");
const ghostPortalRootId = "ghost-portal-root";
const ghostPortalIframeClass = "gh-portal-triggerbtn-iframe";

function pagination(isInfinite, done, isMasonry = false) {
    const feedElement = document.querySelector(".gh-feed");
    if (!feedElement) return;

    let loading = false;
    const target =
        feedElement.nextElementSibling ||
        feedElement.parentElement.nextElementSibling ||
        document.querySelector(".gh-foot");
    const buttonElement = document.querySelector(".gh-loadmore");

    const loadNextPage = async function () {
        const nextElement = document.querySelector("link[rel=next]");
        if (!nextElement) return;

        try {
            const res = await fetch(nextElement.href);
            const html = await res.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");

            const postElements = doc.querySelectorAll(
                ".gh-feed:not(.gh-featured):not(.gh-related) > *"
            );
            const fragment = document.createDocumentFragment();
            const elems = [];

            postElements.forEach(function (post) {
                var clonedItem = document.importNode(post, true);

                if (isMasonry) {
                    clonedItem.style.visibility = "hidden";
                }

                fragment.appendChild(clonedItem);
                elems.push(clonedItem);
            });

            feedElement.appendChild(fragment);

            if (done) {
                done(elems, loadNextWithCheck);
            }

            const resNextElement = doc.querySelector("link[rel=next]");
            if (resNextElement && resNextElement.href) {
                nextElement.href = resNextElement.href;
            } else {
                nextElement.remove();
                if (buttonElement) {
                    buttonElement.remove();
                }
            }
        } catch (e) {
            nextElement.remove();
            throw e;
        }
    };

    const loadNextWithCheck = async function () {
        if (
            target.getBoundingClientRect().top <= window.innerHeight &&
            document.querySelector("link[rel=next]")
        ) {
            await loadNextPage();
        }
    };

    const callback = async function (entries) {
        if (loading) return;

        loading = true;

        if (entries[0].isIntersecting) {
            // keep loading next page until target is out of the viewport or we've loaded the last page
            if (!isMasonry) {
                while (
                    target.getBoundingClientRect().top <= window.innerHeight &&
                    document.querySelector("link[rel=next]")
                ) {
                    await loadNextPage();
                }
            } else {
                await loadNextPage();
            }
        }

        loading = false;

        if (!document.querySelector("link[rel=next]")) {
            observer.disconnect();
        }
    };

    const observer = new IntersectionObserver(callback);

    if (isInfinite) {
        observer.observe(target);
    } else {
        buttonElement.addEventListener("click", loadNextPage);
    }
}

function updatePostCommentCount() {
    // Copied from Ghost implementation https://github.com/TryGhost/Ghost/blob/main/ghost/core/core/frontend/src/comment-counts/js/comment-counts.js
    const countsMap = {};
    const fetchingIds = new Set();

    const api = document.querySelector("[data-ghost-comments-counts-api]")
        .dataset.ghostCommentsCountsApi;

    const debounce = function (func, timeout = 100) {
        let timer;
        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => func.apply(this, args), timeout);
        };
    };

    const addIdsFromElement = function (node) {
        const countElems =
            node.querySelectorAll?.("[data-ghost-comment-count]") || [];

        countElems.forEach((countElem) => {
            if (!countsMap[countElem.dataset.ghostCommentCount]) {
                fetchingIds.add(countElem.dataset.ghostCommentCount);
            }
        });
    };

    const renderCounts = function () {
        for (const [id, count] of Object.entries(countsMap)) {
            const countElems = document.querySelectorAll(
                `[data-ghost-comment-count="${id}"]`
            );
            countElems.forEach((e) => {
                let text = e.dataset.ghostCommentCountEmpty;
                if (count === 1) {
                    if (e.dataset.ghostCommentCountSingular) {
                        text = `${count} ${e.dataset.ghostCommentCountSingular}`;
                    } else {
                        text = count;
                    }
                }
                if (count > 1) {
                    if (e.dataset.ghostCommentCountPlural) {
                        text = `${count} ${e.dataset.ghostCommentCountPlural}`;
                    } else {
                        text = count;
                    }
                }
                if (text) {
                    if (e.dataset.ghostCommentCountAutowrap !== "false") {
                        const el = document.createElement(
                            e.dataset.ghostCommentCountTag
                        );
                        if (e.dataset.ghostCommentCountClassName) {
                            el.classList.add(
                                e.dataset.ghostCommentCountClassName
                            );
                        }
                        el.textContent = text;
                        e.insertAdjacentElement("afterend", el);
                    } else {
                        e.insertAdjacentText("afterend", text);
                    }
                }
                e.remove();
            });
        }
    };

    const fetchCounts = async function () {
        const ids = Array.from(fetchingIds);
        fetchingIds.clear();

        if (!ids.length) {
            return;
        }

        const rawRes = await fetch(`${api}?ids=${ids.join(",")}`, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        });

        if (rawRes.status !== 200) {
            return;
        }

        const res = await rawRes.json();

        for (const [id, count] of Object.entries(res)) {
            countsMap[id] = count;
        }

        renderCounts();
    };

    const countElemObserver = new MutationObserver((mutationsList) => {
        mutationsList.forEach((mutation) => {
            mutation.addedNodes.forEach((addedNode) => {
                addIdsFromElement(addedNode);
                debounce(fetchCounts);
            });
        });
    });

    countElemObserver.observe(document.body, {
        subtree: true,
        childList: true,
    });

    addIdsFromElement(document.body);
    fetchCounts();
}

(function () {
    pagination(true, updatePostCommentCount);
})();

function runOnNonDesktop(e, onMount) {
    // If this function called on dom load, we wait for the Ghost portal to be loaded using MutationObserver.
    if (onMount) {
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((addedNode) => {
                    if (addedNode.id === ghostPortalRootId) {
                        waitForIframe(addedNode);
                        observer.disconnect();
                    }
                });
            });
        });

        observer.observe(document.body, { subtree: false, childList: true });
    } else {
        // Otherwise, assume that Ghost portal DOM is already loaded and injected to the document.
        updatePortalStyle();
    }
}

(function () {
    nonDesktopBreakpoint.addEventListener("change", runOnNonDesktop);
    const onMount = true;
    runOnNonDesktop(nonDesktopBreakpoint, onMount);
})();

function waitForIframe(node) {
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (
                !mutation.addedNodes.length &&
                mutation.target.className === ghostPortalIframeClass
            ) {
                updatePortalStyle();
                observer.disconnect();
            } else if (
                mutation.addedNodes[0]?.className === ghostPortalIframeClass
            ) {
                mutation.addedNodes[0].addEventListener("load", () => {
                    updatePortalStyle();
                });
                observer.disconnect();
            }
        });
    });

    observer.observe(node, {
        subtree: true,
        childList: true,
        attributes: true,
    });
}

function updatePortalStyle() {
    const ghostPortalIframe = document.querySelector(
        `#${ghostPortalRootId} iframe`
    ).contentDocument;

    let bgColor = getComputedStyle(document.body).getPropertyValue(
        "--color-secondary"
    );
    let fgColor = getComputedStyle(document.body).getPropertyValue(
        "--color-darker-gray"
    );

    if (!nonDesktopBreakpoint.matches) {
        bgColor = getComputedStyle(document.body).getPropertyValue(
            "--ghost-accent-color"
        );
        fgColor = "#fff"; // Ghost uses plain white as foreground color in portal button
    }

    // Set CSS custom properties from the theme colors to the iframe document.
    ghostPortalIframe.documentElement.style.setProperty(
        "--brandcolor",
        bgColor
    );
    ghostPortalIframe.documentElement.style.setProperty("--color-fg", fgColor);

    // // Use those variables to set background and foreground colors of the portal button.
    ghostPortalIframe.head.insertAdjacentHTML(
        "beforeend",
        `<style>.gh-portal-triggerbtn-label {color: var(--color-fg);} .gh-portal-triggerbtn-container svg {color: var(--color-fg) !important;} .gh-portal-triggerbtn-container path {color: var(--color-fg) !important; stroke: var(--color-fg) !important;}</style>`
    );
}

(function () {
    if (!document.body.classList.contains("post-template")) return;

    const cover = document.querySelector(".gh-cover");
    if (!cover) return;

    const image = cover.querySelector(".gh-cover-image");

    window.addEventListener("load", function () {
        cover.style.setProperty(
            "--cover-height",
            (image.clientWidth * image.naturalHeight) / image.naturalWidth +
                "px"
        );
        cover.classList.remove("loading");
    });
})();

function removeClassFromRecentArticles(recentTopArticles, index) {
    recentTopArticles.forEach((article, r) => {
        if (r !== index) {
            article.classList.remove("large");
        }
    });
}

(function () {
    const recentTopArticles = document.querySelectorAll(
        ".gh-topic-recent article"
    );
    let i = 0;
    while (i < recentTopArticles.length) {
        if (recentTopArticles[i].classList.contains("featured")) {
            removeClassFromRecentArticles(recentTopArticles, i);
            break;
        }
        i++;
    }
})();
